import { render, staticRenderFns } from "./_QuoteFolderHeader.vue?vue&type=template&id=259921e8&scoped=true"
import script from "./_QuoteFolderHeader.vue?vue&type=script&lang=js"
export * from "./_QuoteFolderHeader.vue?vue&type=script&lang=js"
import style0 from "./_QuoteFolderHeader.vue?vue&type=style&index=0&id=259921e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259921e8",
  null
  
)

export default component.exports